export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-4.29c44d38.png";